import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { IServiceChangeRequest } from '../../../../core/models/service-change-request.model';
import { EServiceChangeRequestReviewSection } from '../../../../core/models/service-change-request-review-issue.model';

@Component({
  selector: 'irembogov-review-officer-form-json-entry',
  templateUrl: './review-officer-form-json-entry.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ReviewOfficerFormJsonEntryComponent {
  @Input() changeRequest!: IServiceChangeRequest;
  @Input() changeRequestThirdPartyFormData!: Record<string, unknown>;
  @Input() activeThirdPartyFormData: Record<string, unknown> | null = null;
  @Input() showDiff = false;
  @Output() reviewOfficerFormJsonCompleted: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  EServiceChangeRequestReviewSection = EServiceChangeRequestReviewSection;
}
